<template>
  <v-menu
    v-model="show"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    nudge-top="24"
    max-width="290"
  >
    <template #activator="{ on }">
      <v-text-field
        ref="datePickerTextField"
        :value="dateText"
        :label="label"
        :rules="rules"
        readonly
        outlined
        dense
        v-on="on"
      >
        <template v-if="popoverTextKey" #append-outer>
          <text-popover :text="$t(popoverTextKey)"></text-popover>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :min="min"
      :max="max"
      :locale="language.datepickerLocale"
      color="primary"
      @change="show = false"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";
import formattedDate from "@/mixins/formattedDate";
import TextPopover from "@/components/globals/TextPopover";

export default {
  name: "SingleDateRangePicker",
  components: {
    TextPopover,
  },
  mixins: [formattedDate],
  props: {
    label: {
      type: String,
      required: true,
    },
    itemDate: {
      type: String,
      required: true,
    },
    min: {
      type: String,
      required: false,
      default: null,
    },
    max: {
      type: String,
      required: false,
      default: null,
    },
    popoverTextKey: {
      type: String,
      required: false,
      default: null,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      date: null,
      show: false,
    };
  },
  computed: {
    dateText() {
      if (!this.date) {
        return "";
      }
      return this.formattedDate(this.date, "DD MMM YYYY");
    },
    rules() {
      if (!this.requiredField) {
        return [];
      }
      return [(v) => !!v || this.$t("requiredFieldError")];
    },
    ...mapState("language", ["language"]),
  },
  watch: {
    itemDate: {
      immediate: true,
      handler(val) {
        this.date = JSON.parse(JSON.stringify(val));
      },
    },
    show(val) {
      if (!val) {
        this.$emit("update:date", this.date);
      }
      this.$emit("update:date-picker", val);
    },
  },
};
</script>
